import React, { PropsWithChildren } from "react";
import ReactMarkdown, { Options } from "react-markdown";
import remarkGfm from "remark-gfm";

const MemoizedReactMarkdown = (props: PropsWithChildren<Options>) => {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} {...props}>
      {props.children}
    </ReactMarkdown>
  );
};

export default React.memo(MemoizedReactMarkdown);
